module.exports = new __parcel__URL__("92112_v.2a2f31f5.jpg").toString();